import clientConfig from '@kbbsdk/config/clientConfig';
import { PARTY_TOWN_GLOBAL_FLIPPER_NAME } from '../common/constants';
import isGtmPreview from '../utils/isGtmPreview';
export const getGtmScripts = ({
  enabledFlippers,
  query,
  cookies
}) => {
  if (!clientConfig.enableGtm || enabledFlippers.indexOf('disable-gtm') !== -1) {
    return [];
  }
  const dataLayer = `window.dataLayer = window.dataLayer || []; window.firedDataLayer = window.firedDataLayer || [];`;
  const gtmScript = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${clientConfig.gtmCode}');`;
  const enablePartyTown = clientConfig.partyTownFlipperName && enabledFlippers.indexOf(clientConfig.partyTownFlipperName) !== -1 && enabledFlippers.indexOf(PARTY_TOWN_GLOBAL_FLIPPER_NAME) !== -1 && !isGtmPreview({
    query,
    cookies
  });
  return [{
    children: dataLayer
  }, {
    ...(enablePartyTown ? {
      type: 'text/partytown'
    } : {}),
    children: gtmScript
  }];
};
export default ({
  enabledFlippers,
  query,
  cookies
}) => getGtmScripts({
  enabledFlippers,
  query,
  cookies
});